import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useAnalyticsByLineQuery, {
	type useAnalyticsByLineQuery$data,
	type useAnalyticsByLineQuery$variables,
} from './components/AnalyticsByLine/__generated__/useAnalyticsByLineQuery.graphql.ts';

export const preloadContentAnalyticsViewers = (contentId: string) =>
	query<useAnalyticsByLineQuery$data, useAnalyticsByLineQuery$variables>({
		query: useAnalyticsByLineQuery,
		variables: { contentId },
	});
